import React from "react";
import gql from "graphql-tag";
import { getPaginatedNodes } from "@components/common/utils";
import { FundsPagePaymentListItem } from "../FundsPagePaymentListItem";
import { FundsPagePaymentListFragment_payment } from "./__generated__/FundsPagePaymentListFragment";

// == Types ================================================================

interface IProps {
  paymentList: FundsPagePaymentListFragment_payment;
}

// == Constants ============================================================

FundsPagePaymentList.fragments = gql`
  fragment FundsPagePaymentListFragment on Campaign {
    id
    payment(id: $id) {
      id
      processedAt
      recipients {
        edges {
          cursor
          node {
            id
            ...FundsPagePaymentListItemFragment
          }
        }
      }
    }
  }
  ${FundsPagePaymentListItem.fragments}
`;

// == Component ============================================================

export default function FundsPagePaymentList({ paymentList }: IProps) {
  const {
    recipients: { edges },
  } = paymentList;

  return (
    <>
      {getPaginatedNodes(edges)?.map((paymentListItem) => (
        <FundsPagePaymentListItem key={paymentListItem?.id} paymentListItem={paymentListItem} />
      ))}
    </>
  );
}

// == Styles ===============================================================
